import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  Renderer2,
  ViewEncapsulation,
} from "@angular/core";
import { timer } from 'rxjs';
import { switchMap, delay, tap } from 'rxjs/operators';
import { Subject } from "rxjs/Subject";
import { AuthService } from "../services/auth.service";
import { constants } from "../utils/constants";
import Swal from 'sweetalert2';
import { RequestService } from "../services/request.service";
import { UserService } from "../services/user.service";

@Component({
  selector: "app-pages",
  templateUrl: "./pages.component.html",
  styleUrls: ["./pages.component.css"],
  encapsulation: ViewEncapsulation.None,
  providers: [ RequestService, UserService ]
})
export class PagesComponent implements OnInit {
  constants: any = constants;
  showFiller = false;
  opened = true;
  touch$ = new Subject<string>();
  userActivity;
  userInactive: Subject<any> = new Subject();
  
  constructor(
    private renderer: Renderer2,
    private eRef: ElementRef,
    public _auth: AuthService
  ) {
    this.renderer.addClass(document.body, "bodyWithoutBack");
    this.setTimeout();
    this.userInactive.subscribe(() => this.closeSession());
  }

  ngOnInit(): void {
    this.touch$.pipe(
      tap(() => this.showFiller = true),
      switchMap(() => timer(3500)),
    )
    .subscribe(() => this.clickout());

    
    if (this._auth.user.getUserData().firstLogin && !this._auth.user.isExecutive()) {
      this.showTerms();
    }    
  }

  closeSession(){
    Swal.close();
    this._auth.logout()
  }

  @HostListener('window:mousemove')
  onMouseMove() {
    clearTimeout(this.userActivity);
    this.setTimeout();
  }



  setTimeout() {
    this.userActivity = setTimeout(() => this.userInactive.next(undefined), 300000);
  }

  
  showTerms() {
    
    Swal.fire({
      allowEscapeKey : false,
      showClass: {
        popup: "animated fadeIn fast",
      },
      hideClass: {
        popup: "animated fadeOut fast",
      },
      showCloseButton: false,
      allowOutsideClick: false,
      html:
        "<img class='logout-icon' src='assets/images/pages/terms.png'/>" +
        "<p>Antes de continuar, te invitamos a descargar la documentación requerida</p>",
      // showConfirmButton: false,
      confirmButtonText: "<a download='Documentos' class='no-underline lh-initial' href='assets/terms.zip'" +
      "><h5 class='primary pointer download-terms'>" +
        "<img src='assets/images/requests/download.png' alt='Descargar documentos'/><b class='ml-5'>Descargar documentos</b></h5></a>",
      customClass: {
        confirmButton: "confirm-button-terms",
        actions: "actions-terms",
      }
    });
  }

  touch() {
    this.touch$.next();
  }

  clickout() {
    document.getElementsByName("listDiv").forEach((element) => {
      this.renderer.removeClass(element, "collapsed");
      this.renderer.removeClass(element, "in");
    });
    this.showFiller = false;
  }
}
